import { useEffect, useRef, useState } from "react";
import { notification } from "antd";
import { useDispatch } from "react-redux";

import { getJobShiftPreStartChecklist } from "../../../../../actions/v2/JobShiftPreStartActions";
import { Strings } from "../../../../../dataProvider/localize";

export default function useJobShiftPreStartViewModel({ open, context }) {
  const dispatch = useDispatch();
  const controller = useRef();

  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [checklist, setChecklist] = useState(null);
  const [sections, setSections] = useState({});

  useEffect(() => {
    if (!open) {
      setLoading(false);
      setLoaded(false);
      setChecklist(null);
      return undefined;
    }

    if (!context || !context.shiftId || !context.swmsId) {
      setLoading(false);
      setLoaded(true);
      setChecklist(null);
      return undefined;
    }

    controller.current = new AbortController();
    setLoading(true);
    setLoaded(false);
    setChecklist(null);

    dispatch(getJobShiftPreStartChecklist(
      {
        jobId: context.jobId,
        swmsId: context.swmsId,
        shiftId: context.shiftId
      },
      { signal: controller.current.signal }
    ))
      .then((res = {}) => {
        setChecklist(res.pre_start_checklist || null);
        setSections(res.sections || {});
      })
      .catch((error) => {
        const message = typeof error === "string"
          ? error
          : (error && error.message ? error.message : "There was an error while fetching the Pre-Start Checklist.");

        notification.error({
          message: Strings.error_title,
          description: message,
          className: "ant-error"
        });
      })
      .finally(() => {
        setLoading(false);
        setLoaded(true);
      });

    return () => {
      if (controller.current) {
        controller.current.abort();
      }
    };
  }, [dispatch, open, context && context.swmsId, context && context.shiftId, context && context.jobId]);

  return {
    loading,
    loaded,
    checklist,
    sections
  };
}
